
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/helen",
      function () {
        return require("private-next-pages/helen/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/helen"])
      });
    }
  